var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"fixed z-40 bg-gray-500 bg-opacity-50 inset-0 min-h-screen flex items-center justify-center overflow-y-auto overflow-x-hidden",attrs:{"aria-labelledby":"modal-title","role":"dialog","aria-modal":"true"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }